import { useAuthStore } from '@/stores/auth';

export const useAuth = () => {
  const user = useAuthStore((state) => state.user);
  const userType = useAuthStore((state) => state.userType);
  const isLoading = useAuthStore((state) => state.isLoading);
  const isAuthenticated = !!user;

  return {
    user,
    userType,
    isLoading,
    isAuthenticated,
  };
};
